require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-articles-on-phones.json") })
        }
      }, "path---es-articles-articles-on-phones");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-articles-on-phones!./.cache/json/es-articles-articles-on-phones.json
// module id = 2063
// module chunks = 231608221292675